import React from 'react';
import styles from './Home.module.scss';
import { axiosBackend}  from '../../axios/Axios.js';
import { useRef, useState, useEffect, useContext } from 'react';
import Loading from "../../components/Loading/Loading"
import { getToken } from "../../services/auth";
import UserContext from "../../context/User";
import { useSnackbar } from 'notistack';
import { IconUpdateDB } from '../../assets/iconUpdateDB';

const USER_URL = "/user"

function HomeContent(props) {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar()
  const [user, setUser] = useState({"photo": require('../../assets/vnn_logo.png'), "email": "", "name": "", "title": ""});
  const [loading, setLoading] = useState(true);
  const [errMsg, setErrMsg] = useState('');
  
  let config = {
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${getToken()}`
    },
  }

  const updateLogo = () => {
    setLoading(true);
    config.headers['update'] = true
    axiosBackend.get(
      USER_URL,
      config
  ).then( (res) => {
      enqueueSnackbar('Informações atualizadas com sucesso.', { 
        variant: 'success'
    });
      setUser(res.data)
      setLoading(false)
  })
      .catch(err => {
        enqueueSnackbar('Falha ao atualizar informações.', { 
          variant: 'error'
      });
        setErrMsg(err.message);
  });
  setLoading(false);
  }

  useEffect(() => {
    try {
    axiosBackend.get(
        USER_URL,
        config
    ).then( (res) => {
        setUser(res.data)
        setLoading(false)
    })
        .catch(err => {
          setErrMsg(err.message);
    });
    } catch (err) {
    if (!err?.response) {
        setErrMsg("No Server Response");
    } else if (err.response?.status === 400) {
        setErrMsg("Não sei não");
    } else if (err.response?.status === 401) {
        setErrMsg("Unauthorized");
    } else {
        setErrMsg("Auth Failed");
    }
    setLoading(false)
    }
  }, []);

  return (
      
      <div className={styles.group1}>
        {loading && ( // Mostra o componente de loading se o estado for verdadeiro
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 9999,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
          <img className={styles.imgLoading} src={require('../../assets/loading.gif')} />
        </div>
      )}
        <div className={styles.flex_col1}>
          <div className={styles.flex_row2}>
            <div className={styles.icon_div}>
              <img className={styles.icon6} src={user.photo} alt="alt text" />
            </div>
            <div className={styles.flex_col2}>
              <h4 className={styles.highlight}>{user.name}</h4>
              <h4 className={styles.highlight1}>{user.title}</h4>
            </div>
            <button className={styles.updateInfoButton} onClick={() => {updateLogo();}}><IconUpdateDB size={16}/></button>
          </div>
          <h1 className={styles.big_title}>Olá, seja bem vindo(a)! </h1>
        </div>
      </div>
  );
}

export default HomeContent;
